module.exports = __webpack_public_path__ + "static/media/_ME10762.454b2962.jpg";